import { render, staticRenderFns } from "./PrincipiosBomPescador.vue?vue&type=template&id=765e50ec&scoped=true&"
var script = {}
import style0 from "./PrincipiosBomPescador.vue?vue&type=style&index=0&id=765e50ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e50ec",
  null
  
)

export default component.exports